import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import * as Roles from '../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'logbook',
        url: '/logbook/:beginDate/:endDate',
        component: 'wtLogbookState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve
            // accessible to all roles
        },
        params: {
            beginDate: '',
            endDate: ''
        },
        data: {
            icon: 'fa-book',
            displayName: 'Logbook',
            editRoles: [Roles.master, Roles.engineer, Roles.operator],
            editButtonVisibility: () => false
        }
    }];

export default states;